module.exports = __webpack_public_path__ + "static/media/loc1_img1.d64ea931.jpg";